import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import generic from './generic';
import identification from './login';
import choice from './choice';
import letter from './letter';
import otp from './otp';
import captcha from './captcha';
import reset from './reset';
import add from './add';
import confirm from './confirm';
import probes from './probes';
import error from './error';
import { path } from '../conf/route.conf';

const createAppReducer = (history) => combineReducers({ //eslint-disable-line
  generic,
  identification,
  choice,
  letter,
  otp,
  captcha,
  reset,
  add,
  confirm,
  probes,
  error,
  router: connectRouter(history),
});

const createRootReducer = (history) => (state, action) => { //eslint-disable-line
  if (action.type === 'RESET_STORE') {
    return createAppReducer(history)({
      generic: {
        whitelistPages: [path.LOGIN, path.ERROR],
        webViewMode: state.generic.webViewMode,
        qs: state.generic.qs,
        isFirstConnection: state.generic.isFirstConnection,
      },
      identification: {
        login: state.choice.identities.login,
      },
    }, action);
  }
  return createAppReducer(history)(state, action); // eslint-disable-line
};

export default createRootReducer;
